import type { ButtonProps, SvgIconProps } from "@mui/material";

export const floatingToolbarStyles: Record<
  "floating" | "toolbar",
  {
    button: ButtonProps["sx"];
    formatIcon: SvgIconProps["sx"];
  }
> = {
  floating: {
    button: {
      border: 0,
      display: "flex",
      bgcolor: "transparent",
      borderRadius: "10px",
      p: 1,
      cursor: "pointer",
      mr: 0.25,
    },
    formatIcon: {
      backgroundSize: "contain",
      height: "18px",
      width: "18px",
      mt: 0.25,
      display: "flex",
    },
  },
  toolbar: {
    button: {},
    formatIcon: {},
  },
};
